import * as L from 'leaflet';
import Spinner from 'spin';

// TODO -- Is this class needed? Can it be combined with the inheriting class in
// calling code or something simpler? The structure is left over from ReactLeaflet.

const LoadingTileLayer = L.TileLayer.extend({

  /**
   * @override
   */
  onAdd: function (map) {

    // Add the spinner el first
    if (!this._spinnerElement) {
      this._addSpinner(map);
    }

    L.TileLayer.prototype.onAdd.apply(this, arguments);
  },

  /**
   * @override
   */
  onRemove: function (map) {
    L.TileLayer.prototype.onRemove.apply(this, arguments);
    this._removeSpinner(map);
  },

  /**
   * @override
   */
  _update: function () {
    L.TileLayer.prototype._update.apply(this, arguments);
    this._updateView();
  },

  _tileLoaded: function () {
    if (!this._tilesToLoad) {
      this._removeSpinner(this._map);
    }
  },

  _updateView: function () {
    if (this._spinner) {
      const center = this._map.latLngToLayerPoint(this._map.getCenter());
      const size = '50 px';

      L.DomUtil.setPosition(this._spinnerElement, center);
      this._spinnerElement.style.width = size;
      this._spinnerElement.style.height = size;
      this._spinner.spin(this._spinnerElement);
    }
  },

  _addSpinner: function (map) {
    this.on('load', this._tileLoaded);
    this._spinnerElement = L.DomUtil.create('div',
      'leaflet-zoom-hide leaflet-loading-image-spinner');
    map._panes.overlayPane.appendChild(this._spinnerElement);
    this._spinner = new Spinner(this.options.spinnerOpts || {});
  },

  _removeSpinner: function (map) {
    this.off('load', this._tileLoaded);
    // Only remove it if exists, can happen in two different cases:
    // 1. when a tile is loaded
    // 2. Layer is removed before tile loaded
    if (this._spinner) {
      this._spinner.stop();
      this._spinner = null;
      map.getPanes().overlayPane.removeChild(this._spinnerElement);
    }
  }

});

export default LoadingTileLayer;
